import cssMobile from '../../../css/editorMobile.module.css'
import {useAppSelector} from '../../../stores/configureStore'
import MirrorArrows from '../../toolbox/MirrorArrows'
import ControlsBase from './ControlsBase'

interface ControlsProps {
  open: boolean
  onBackClick?: () => void
}

export default function MirrorControls({open, onBackClick}: ControlsProps) {
  const selectedImage = useAppSelector(store =>
    store.editor.images.find(
      image => image.id === store.editor.selectedImageId,
    ),
  )

  return (
    <ControlsBase open={open} onBackClick={onBackClick}>
      {selectedImage && (
        <div className={cssMobile.controlItemsRow}>
          <MirrorArrows img={selectedImage} />
        </div>
      )}
    </ControlsBase>
  )
}
